import React, { useEffect, useState } from 'react';
import api from '../services/api';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import '../styles/floatingForm.css'
import gsap from 'gsap';

const CreateCategory = ({setShowCreateCategory, containerRef, categoryId, setCategoryId, categoryName, setCategoryName}) => {
    const [categories, setCategories] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [errors, setErrors] = useState({});
  
  
    const fetchCategories = async () => {
      try {
        const response = await api.get('/category/get-all');
        setCategories(response.data.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
  
    const handleDelete = async (id) => {
      try {
        await api.delete(`/category/delete/${id}`);
        setCategories(categories.filter(category => category.id !== id));
        toast.success(`Category with ID ${id} deleted successfully`);
      } catch (error) {
        console.error('Error deleting category:', error);
        toast.error('Error deleting category');
      }
    };

    const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};

    if (!categoryName.trim()) errors.categoryName = 'Category Name cannot be empty';

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setErrors({});

    


    try {
      if (categoryId) {
        // Update existing category
        const response = await api.post(`/category/update/${categoryId}`, {
          name: categoryName,
        });
        if (response.data.status === "success") {
          toast.success(`Category updated successfully!`);
          setCategoryId(null); // Reset categoryId after update
          handleCancel()
        } else {
          toast.error('Failed to update category');
        }
      } else {
        // Create new category
        const response = await api.post('/category/add', {
          name: categoryName,
        });
        if (response.data.status === "success") {
          toast.success(`Category created successfully!`);
          handleCancel()
        } else {
          toast.error('Failed to create category');
        }
      }
      setCategoryName('');
      setShowModal(false);
      fetchCategories(); // Refresh the category list
    } catch (error) {
      console.error('Error saving category:', error);
      toast.error('Error saving category');
    }
  };

  function handleCancel(){
     if (containerRef.current) {
        gsap.to(containerRef.current, {
            autoAlpha: 0,
            y: 50,
            duration: 0.4,
            ease: "power2.in",
            onComplete: () =>    setShowCreateCategory(false),
        });
        } else {
            setShowCreateCategory(false);
        }
  }


  return (
    <div className='floating-form-container smaller' ref={containerRef} >
      <div className="heading">
        <h2>Category Details</h2>
      </div>

        <form onSubmit={handleSubmit}>
            <div className="form-container">

                <div className="section-1">

                    <div className="input-container-floating-form wid-100">
                        <label htmlFor='vendor'>Category Name *</label>
                        <input type="text" className={`form-control ${errors.categoryName ? 'is-invalid' : ''}`} value={categoryName} onChange={(e) => setCategoryName(e.target.value)} />
                    <b>{errors.categoryName && <span className='text-danger small'>{errors.categoryName}</span>}</b>
                    </div>

                </div>


            </div>

            <div className="form-btn-container">

                <button type='submit'>{categoryId ? 'Update' : 'Create'}</button>
                <button type='reset' onClick={handleCancel}>Cancel</button>

            </div>


        </form>

    </div>
  );
};

export default CreateCategory;
